import styled from 'styled-components';

export const Container = styled.div<{ $height?: string; $width?: string }>`
  svg {
    inline-size: ${({ $width }) => $width || 'inherit'};
    block-size: ${({ $height }) => $height || 'inherit'};
  }
`;
